import DashboardLayout from '../layouts/Dashboard.vue';
import DashboardSystem from '../layouts/Dashboard_System.vue'
import WindowsShow from '../layouts/WindowShow.vue';

const render_layout = (to, from) => {
    const layout = to.meta.layout || 'default';
    // console.log(to)
    // console.log(from)
    switch(layout) {
      case "windows":
        to.meta.layoutComponent = WindowsShow;
        break;
      case "system":
        to.meta.layoutComponent = DashboardSystem;
        break;
      default:
        to.meta.layoutComponent = DashboardLayout;
        break;
    }
    for (const key in from.meta) {
      if (key !== 'layout' && key !== 'layoutComponent' && to.meta.hasOwnProperty(key)) {
        if (key === 'mySystem') {
          // to.meta.mySystem = from.meta.mySystem
          // console.log(from.meta.mySystem)
        }
        to.meta[key] = from.meta[key];
      }
    }
    // console.log(from.meta);
    // console.log(to.meta);
    return to
}

export { render_layout }